import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function VoiceSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Reader Voices"
          title="读者怎么说"
          desc="来自长期读者、从业者与线索提供者的真实反馈，帮我们持续校准时间线的呈现方式。"
        />
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <article
              key={item.name}
              className="flex flex-col gap-4 p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: item.rating }).map((_, index) => (
                  <i key={index} className="ri-star-fill" />
                ))}
                {Array.from({ length: 5 - item.rating }).map((_, index) => (
                  <i key={`empty-${index}`} className="ri-star-line text-background-400" />
                ))}
              </span>
              <p className="text-sm leading-relaxed text-foreground-700">{item.text}</p>
              <div className="mt-auto pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-heading font-bold">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}